<script lang="ts" setup>
import {computed} from 'vue';
import {useI18n} from 'vue-i18n';
import type {LibraryMediaTypeDTO} from '@/ts/types/dto/recco/library.dto';
import {statusMarkerLabelKey} from '@/ts/utils/recco-label-keys';

const props = defineProps<{
  mediaType: LibraryMediaTypeDTO;
}>();

const {t: $t} = useI18n();

const label = computed<string>(() => $t(statusMarkerLabelKey[props.mediaType]));
</script>

<template>
  <span class="consumed-marker" aria-hidden="true">
    <q-icon name="visibility" class="consumed-marker__icon"/>
    {{ label }}
  </span>
</template>

<style lang="scss" scoped>
// Overlaid on a card's media (parent must be positioned); takes precedence over the "Recommended" pill.
.consumed-marker {
  @include card-image-chip-overlay;
  position: absolute;
  bottom: var(--Spacing-spacing-3);
  left: var(--Spacing-spacing-3);
  z-index: 2;
}

.consumed-marker__icon {
  font-size: 12px;
}
</style>
